import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { seoConfig } from '../lib/config/next-seo.config';
import { DefaultSeo } from 'next-seo';
import '../lib/translations/i18n';
import './styles.css';
import React, { useState } from 'react';
import { CustomToaster, DestructionConfirmModal, DestructiveConfirmContext, InitialConfirmState, HotjarInjector } from '@yalendar/shared/ui-core';
import Script from 'next/script';
import { TrackingProvider } from '../contexts/trackers';
import AxeptioInjector from '../components/AxeptioInjector';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'react-modal-video/scss/modal-video.scss';
import Router, { useRouter } from 'next/router';
import { UserContext } from '../hooks/useAuth';
import useFindUser from '../hooks/useFindUser';
Router.events.on('routeChangeStart', function (url) {
  NProgress.start();
});
Router.events.on('routeChangeComplete', function () {
  return NProgress.done();
});
Router.events.on('routeChangeError', function () {
  return NProgress.done();
});
export function reportWebVitals(metric) {//console.log(metric);
}
App.getInitialProps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            browserConfigProps: {
              apiBaseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
              frontURL: process.env.NEXT_PUBLIC_FRONT_URL,
              appURL: process.env.NEXT_PUBLIC_APP_BASE_URL,
              stripePublicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY,
              googleAnalyticsTrackingCode: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
              hsChatId: process.env.NEXT_PUBLIC_HS_CHAT_ID,
              axeptioClientId: process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID,
              siteMapEnabled: process.env.NEXT_PUBLIC_SITEMAP_ENABLED,
              hotjar: {
                HJID: process.env.NEXT_PUBLIC_HOTJAR_HJID,
                HJSV: process.env.NEXT_PUBLIC_HOTJAR_HJSV
              }
            }
          });

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
var style = 'font-size: 24px;' + 'background: #67b26f; /* fallback for old browsers */' + 'background: -webkit-linear-gradient(to right, #67b26f, #3730a3); /* Chrome 10-25, Safari 5.1-6 */' + 'background: linear-gradient(to right, #67b26f, #3730a3); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */' + 'color: white;' + 'text-align: center;' + 'padding: 10px 15px;' + 'width: 100%;' + 'border-radius: 20px;';
var text = "%cLet's talk business🙏. contact@kreezus.com";
console.log(text, style);

function App(_ref2) {
  var Component = _ref2.Component,
      pageProps = _ref2.pageProps,
      browserConfigProps = _ref2.browserConfigProps;
  var router = useRouter();
  var isEmbeded = router.query.embeded !== undefined && router.query.embeded === '1'; // set browserConfigProps for all pageProps

  if (!pageProps) pageProps = {};
  browserConfigProps.isEmbeded = isEmbeded;
  pageProps.browserConfigProps = browserConfigProps; // Use the layout defined at the page level, if available

  var getLayout = Component.getLayout || function (page) {
    return page;
  };

  var _useState = useState(false),
      showDestructiveConfirm = _useState[0],
      setShowDestructiveConfirm = _useState[1];

  var _useState2 = useState(InitialConfirmState),
      destructiveConfirmState = _useState2[0],
      setDestructiveConfirmState = _useState2[1];

  var _useFindUser = useFindUser(browserConfigProps.apiBaseURL),
      user = _useFindUser.user,
      setUser = _useFindUser.setUser,
      isLoading = _useFindUser.isLoading,
      currentMembership = _useFindUser.currentMembership,
      setCurrentMembership = _useFindUser.setCurrentMembership;

  return getLayout( /*#__PURE__*/_jsxs(DestructiveConfirmContext.Provider, {
    value: {
      show: showDestructiveConfirm,
      setShow: setShowDestructiveConfirm,
      confirmState: destructiveConfirmState,
      setConfirmState: setDestructiveConfirmState
    },
    children: [/*#__PURE__*/_jsxs(UserContext.Provider, {
      value: {
        user: user,
        setUser: setUser,
        isLoading: isLoading,
        currentMembership: currentMembership,
        setCurrentMembership: setCurrentMembership
      },
      children: [/*#__PURE__*/_jsxs(TrackingProvider, {
        browserConfigProps: browserConfigProps,
        children: [/*#__PURE__*/_jsx(DefaultSeo, _objectSpread({}, seoConfig.defaultNextSeo)), /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps)), /*#__PURE__*/_jsx(CustomToaster, {})]
      }), !isEmbeded && browserConfigProps.axeptioClientId && /*#__PURE__*/_jsx(AxeptioInjector, {
        axeptioClientId: browserConfigProps.axeptioClientId
      }), !isEmbeded && browserConfigProps.hsChatId &&
      /*#__PURE__*/
      // TODO Load hubspot after page completly loaded, Why not use next/script
      // <HubspotChatInjector hsChatId={browserConfigProps.hsChatId} />
      _jsx(Script, {
        id: "hs-script-loader",
        src: "//js-eu1.hs-scripts.com/".concat(browserConfigProps.hsChatId, ".js"),
        strategy: "lazyOnload" //afterInteractive
        ,
        async: true,
        defer: true
      }), browserConfigProps.hotjar.HJID && browserConfigProps.hotjar.HJSV && /*#__PURE__*/_jsx(HotjarInjector, {
        HJID: browserConfigProps.hotjar.HJID,
        HJSV: browserConfigProps.hotjar.HJSV
      })]
    }), /*#__PURE__*/_jsx(DestructionConfirmModal, {})]
  }));
}

export default App;